import {Component} from '@angular/core';
import {BaseModalComponent} from "app/views/modal/base_modal.component";
import {SupportService} from "../support.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment-timezone";

@Component({
	templateUrl: './edit_site.component.html'
})
export class EditSiteModalComponent extends BaseModalComponent {
	domainUrl: string;
	siteId: string;
	category: string = '';
	subject: string = '';
	defer: string = '';
	oldCategory: string = '';
	oldSubject: string = '';
	isSupport: boolean;
	categories: any[] = [];
	subcategories: string[];
	lastEditUser: string = '';
	lastEditTime: string = '';
	preview: string = '';

	constructor(public activeModal: NgbActiveModal, public supportService: SupportService) {
		super(activeModal);
	}

	public calcSubcategories() {
		this.subcategories = [];

		for (let subcategory in this.categories[this.category]) {
			this.subcategories.push(subcategory);
		}
	}
	
	async ngOnInit() {
		this.oldCategory = this.category;
		this.oldSubject = this.subject;
		this.calcSubcategories();
	}

	async ok() {
		await this.supportService.checkAndSaveSupportEdit(this.siteId, this.category, this.subject, this.defer, this.oldCategory, this.oldSubject,true).toPromise();

		this.close();
	}
}
